import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../notifications/notification.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notif = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Permet de désactiver le toast global si besoin
      if (!req.headers.has('skipErrorHandler')) {
        if (error.status === 0) {
          notif.error('Impossible de joindre le serveur');
        } else if (error.status === 401) {
          notif.error('Session expirée, veuillez vous reconnecter');
        } else if (error.status >= 500) {
          notif.error('Erreur interne du serveur');
        } else {
          notif.error(error.error?.message || 'Une erreur est survenue');
        }
      }

      return throwError(() => error);
    })
  );
};
